import { supabase } from './supabaseClient';

// Stage A trusted identity resolution is preserved; operational writes use scoped RPCs.
export class CrewIdentityError extends Error {
  readonly code?: string;
  readonly status?: number;
  constructor(code?: string, status?: number) {
    super('Staff access unavailable. Please contact Admin.');
    this.name = 'CrewIdentityError';
    this.code = code;
    this.status = status;
  }
}

export async function loadCrewIdentity() {
  // Retain only the structured classification, not response bodies or identity data.
  const { data, error, status } = await supabase.rpc('crew_identity');
  if (error) throw new CrewIdentityError(error.code, status);
  if (!data) throw new CrewIdentityError('identity_missing');
  return data;
}

// Stage 2 self-profile allowlist; identity, role and commercial fields are never sent.
export const SELF_PROFILE_FIELDS = [
  'legal_name', 'dob', 'home_airport', 'license_number', 'license_expiry',
  'shirt_size', 'dietary_requirements', 'emergency_contact_name',
  'emergency_contact_phone', 'avatar_url',
] as const;

export async function crewOperation(name: string, args: Record<string, unknown>) {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw new Error(error.message || 'Could not save. Please refresh and try again.');
  return data;
}

export async function saveCrewProfile(form: Record<string, unknown>) {
  const patch = Object.fromEntries(SELF_PROFILE_FIELDS
    .filter(field => Object.prototype.hasOwnProperty.call(form, field))
    .map(field => [field, form[field] === '' ? null : form[field]]));
  const { data, error } = await supabase.rpc('crew_update_profile', { p_patch: patch });
  if (error || !data) throw new Error('Profile could not be saved. Please try again.');
  return data;
}
